import { Link } from "react-router-dom";
import React from "react";
import { QueryResult } from "@apollo/client";
import { Button } from "components/haven-design/buttons";
import { WaitlistUpdateRequestStatus as Status,
  RequestedCounts_interestList_scheduledUpdate_requestedCounts as Count,
  RequestedCounts,
  RequestedCountsVariables } from "types/gql-types";
import { InterestList } from "../../types";
import styles from "./manual-contact.module.css";

type Props = {
  interestList: InterestList;
  countResults: QueryResult<RequestedCounts, RequestedCountsVariables>;
}

const countByStatus = (
  counts:Count[],
  statuses:Status[],
):number => counts
  .filter((count) => statuses.includes(count.status))
  .reduce((acc, current) => acc + current.totalCount, 0);

const ManualContact: React.FC<Props> = (props) => {
  const serverCount = props.countResults.data?.interestList.scheduledUpdate.requestedCounts;
  const count = countByStatus(serverCount ?? [], [
    Status.ALL_BOUNCED,
    Status.UNREACHABLE,
    Status.UNREACHABLE_LANDLINE_ONLY,
  ]);

  return (
    <div className={styles.content}>
      <div>
        <p>
          Applicants that must be called as they have no other contact information.
          <br />
          <em>Total to call: </em> {count} applicants
        </p>
        <Link to={`/dash/manager/update/${props.interestList.id}/contact`}>
          <Button disabled={count === 0} color="primary" size="S">
            Contact applicants
          </Button>
        </Link>
      </div>
    </div>
  );
};
export default ManualContact;
